import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import Form from './form';
// import Grid from './grid';
import UploadStatus from './uploadstatus';
import './bulkbooking.css'

const BulkBooking = () => {
    const state = useSelector(state => { return { appData: state.appData, bulkBookingData: state.bulkBookingData } });
    const { userInfo } = state.appData;
    const { gridStatus } = state.bulkBookingData;

    const history = useHistory();

    const myWorker = React.useRef(new Worker('./bulkwebworker.js'));
    let worker = myWorker.current;
    useEffect(() => {
        if (!worker) {
            worker = new Worker('./bulkwebworker.js')
        }
        return () => {
            worker.terminate();
            worker = null;
        }
    }, [])

    useEffect(() => {
        if (!valdiatePage('/bulkbooking')) {
            history.push('/login');
        }
    }, []);

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Bulk Booking</h1>
        </div>
        <div className="card sticky" style={{ padding: 10 }}>
            <Form myWorker={worker} />
            {/* {grid && grid.length > 0 && <Grid />} */}
            {gridStatus && gridStatus.length > 0 && (
                <UploadStatus data={gridStatus} />
            )}
        </div>
    </section>
}

export default BulkBooking;